import * as api from "@/api/williams/welders";
import { queryKeys } from "../../queryKeys";
import { useQuery } from "react-query";

export function useWelderMetrics(id: string) {
  return useQuery({
    queryKey: queryKeys.welder.metrics(id),
    queryFn: () => api.getWelderMetrics(id),
  });
}
